import type { SVGProps } from 'react';

const SvgRevert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M13 8.005H9.41l1.29-1.29a.996.996 0 1 0-1.41-1.41l-3 3a.996.996 0 0 0 0 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29h3.59c1.65 0 3 1.35 3 3s-1.35 3-3 3h-5c-.55 0-1 .45-1 1s.45 1 1 1h5c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    />
  </svg>
);
export default SvgRevert;
